/**
 * Config global do frontend WOS.
 * Lê de import.meta.env (Vite injeta vars VITE_*).
 *
 * Padrão herdado do crm_react: módulo singleton acessado por `config.apiUrl`.
 */

interface AppConfig {
  apiUrl: string;
  devPort: number;
}

function buildConfig(): AppConfig {
  const env = import.meta.env;
  return {
    apiUrl: (env.VITE_API_URL ?? "http://localhost:3543").replace(/\/$/, ""),
    devPort: Number(env.VITE_DEV_PORT ?? 5743),
  };
}

export const config: AppConfig = buildConfig();
